export default "__VITE_ASSET__g7SV6kJx__"